import ImageLoading from "../../../assets/images/icons/loading.svg";
import { useTheme } from "../../../contexts/ThemeContext";
import getThemeColors from "../../../utils/getColorTheme";

const Loading = ({ style }) => {
  const { addTheme } = useTheme();
  const { theme, background } = getThemeColors(addTheme);

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "16px" }}>
      <img
        src={ImageLoading}
        style={{ 
          animation: "spin .7s linear infinite",
          filter: addTheme === 'dark' ? 'invert(1)' : 'none',
          ...style 
        }}
        loading="lazy"
        height={50}
        width={50}
        alt="Loading..."
      />
      <span style={{ color: theme, fontSize: "14px" }}>Loading...</span>
    </div>
  );
};

export default Loading;
